// SAN-1929: navigator.clipboard.writeText rejects with NotAllowedError when a
// permissions policy blocks it (e.g. the app embedded in an iframe), and is
// undefined outside a secure context. Callers awaited it unguarded, so the
// rejection went to Sentry and the "copied" toast never showed. Try the
// async Clipboard API first, fall back to a hidden textarea +
// execCommand('copy'), and report the outcome instead of throwing.
export const COPY_FAILED_MESSAGE = "Couldn't copy the link. Please copy it manually.";

export async function copyToClipboard(text: string): Promise<boolean> {
  const value = text ?? '';
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    // blocked or denied: try the legacy path below
  }
  return legacyCopy(value);
}

function legacyCopy(value: string): boolean {
  if (typeof document === 'undefined' || !document.body) return false;
  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '0';
  textarea.style.left = '-9999px';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  try {
    textarea.select();
    return document.execCommand('copy');
  } catch {
    return false;
  } finally {
    document.body.removeChild(textarea);
  }
}
